import type { SeriesOptionsType } from 'highcharts';
import { memo } from 'react';
import { ChartLegendItem } from './ChartLegendItem';

interface IProps {
    seriesData: (SeriesOptionsType & { color: string })[];
    chart?: Highcharts.Chart;
}

export const CashFlowChartLegend = memo<IProps>(({ seriesData, chart }) => (
    <div className="chart-legend">
        {seriesData.map((series) => (
            <ChartLegendItem chart={chart} name={series.name ?? ''} color={series.color} type={series.type} key={series.name} />
        ))}
    </div>
));
